import { ComplaintStatus, statusList } from "@modules/plaintes/plaintes.model.ts";
import { addLocale } from "primereact/api";
import { Calendar } from "primereact/calendar";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import React from "react";

interface SolutionProps {
  textAreaValue: string;
  setTextAreaValue: (a: string) => void;
  agentPartnerName: string;
  selectedStatus: string;
  setSelectedStatus: (a: string) => void;
  date: any;
  errors: any;
  setErrors: (a: any) => void;
  isDisabled: boolean
}
const Solution: React.FC<SolutionProps> = ({
  textAreaValue,
  setTextAreaValue,
  agentPartnerName,
  selectedStatus,
  setSelectedStatus,
  date,
  errors,
  setErrors,
  isDisabled
}) => {
  addLocale("fr", {
    firstDayOfWeek: 1,
    dayNames: [
      "dimanche",
      "lundi",
      "mardi",
      "mercredi",
      "jeudi",
      "vendredi",
      "samedi",
    ],
    dayNamesShort: ["dim", "lun", "mar", "mer", "jeu", "ven", "sam"],
    dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
    monthNames: [
      "Janvier ",
      "Février ",
      "Mars ",
      "Avril ",
      "Mai ",
      "Juin ",
      "Juillet ",
      "Août ",
      "Septembre ",
      "Octobre ",
      "Novembre ",
      "Décembre ",
    ],
    monthNamesShort: [
      "janv",
      "févr",
      "mars",
      "avr",
      "mai",
      "juin",
      "juil",
      "août",
      "sept",
      "oct",
      "nov",
      "déc",
    ],
    today: "Aujourd'hui",
    clear: "Effacer",
  });
  const dateFormat = date.split(",")[0];

  return (
    <div className="rounded-[10px] bg-white flex flex-col p-4">
      {isDisabled && (
        <div className="w-full text-center text-red-400">
          <i>Cette plainte est résolue. Le transfert n'est plus possible.</i>
        </div>
      )}
      <span className="text-black text-sm font-semibold mb-2">Solution :</span>
      <div className="w-full flex items-center">
        <div className="w-full">
          <div className="flex flex-wrap gap-3 w-full mb-1">
            <label htmlFor="complainantName" className="block font-medium">
              Action entreprise (obligatoire)
            </label>
            <InputTextarea
              value={textAreaValue}
              disabled={isDisabled}
              onChange={(e) => {
                setTextAreaValue(e.target.value);
                setErrors({ ...errors, action: "" });
              }}
              rows={5}
              placeholder="Entrez votre texte ici..."
              autoResize
              className="w-full"
            />
          </div>
          {errors.action && (
            <small className="text-red-600">{errors.action}</small>
          )}
          <div>
            <label htmlFor="complainantName" className="block font-medium mb-2">
              {/* Nom de l'agent du [nom du partenaire externe] */}
              Nom de l'agent interne ou MPS
            </label>
            <InputText
              value={agentPartnerName}
              disabled
              placeholder="Entrer le nom de l'agent"
              className="w-full"
              maxLength={255}
            />
          </div>
        </div>
      </div>
      <div className="gap-3 grid grid-cols-1 lg:grid-cols-2">
        <div className="flex-auto column gap-2 w-full">
          <label htmlFor="date">Date</label>
          <Calendar
            locale="fr"
            placeholder="dd/mm/yyyy"
            id="buttondisplay"
            value={new Date(dateFormat)}
            dateFormat="dd/mm/yy"
            showIcon
            disabled
          />
        </div>
        <div className="flex-auto column gap-2 w-full">
          <label htmlFor="status">Changer le status (obligatoire)</label>
          <Dropdown
            id="status"
            disabled={isDisabled}
            value={selectedStatus}
            onChange={(e: DropdownChangeEvent) => {
              setSelectedStatus(e.value);
              setErrors({ ...errors, status: "" });
            }}
            options={statusList.filter(
              (i) => i.code !== ComplaintStatus.ARCHIVED
            )}
            optionLabel="name"
            placeholder="---Changer le statut---"
            className="w-full md:w-14rem"
          />
          {errors.status && (
            <small className="text-red-600">{errors.status}</small>
          )}
        </div>
      </div>
    </div>
  );
};

export default Solution;
